const SgiTreeEO = function () {
    return {
        // c: "title", //树显示字段名
        // cId: "EOCat", //组件标识
        ctlH: '100%',
        // ctlW: '100%',
        desId: "EP_EO_UI_3007",
        // insName: "EOCat", //绑定实例名
        isBrdr: false,
        mgn: "0 0 0 0",
        ndIsChk: false, //树节点是否可选
        ndIsDg: false, //树节点是否可拖拽
        ndisLine: true, //树节点是否连线
        pad: "0 0 0 0",
        selFirst: false, //初始化后选择首行
        // sNo: 0,
        // sc: "EOCat", //语义码
        // cpB: 0,
        // csstyle: "80",
        ctlN: "树", //组件名
        // disCustom: false, //只显示自定义菜单
        // flx: 0,
        // iconPh: "SD_RP_IR_0001`UI`UI07",
        // isBatch: false,
        // isBdyBrdr: true,
        // isClp: false, // 面板是否可以折叠
        // isClpFst: true, // 是否面板展开或收缩的顺序
        // isCls: false, // 面板是否可以关闭
        // isDis: false,
        // isFrm: false, // 面板是否填充
        // isHClpTl: false, // 是否显示折叠按钮
        // isHdn: false,
        // isMsMu: false, //使用右键菜单
        // isRead: false,
        // isScl: false,
        // isShRoot: false,
        // isTbTr: false,
        // isTlb: false, //显示工具条
        // isTtl: false,
        // isttlClp: false, // 是否单击面板头部折叠
        // te: "标签名", //显示名称
        // tlbIsTtl: true, //显示标题
        // ttlAlg: "top", // 面板标题位置
        // ttlAlgn: "left", // 面板标题对齐方式
        // useTim: 0,
        // visible: true,
        // animate:true, //树展开收起展示动画效果
        // autoScroll:true, //自动滚动
        // overflowY:"auto", //自动启动垂直滚动条
        // rootVisible:false, //树根是否显示
        // clpDrt: "top", // 面板的折叠方向
        // clpd: false, // 面板初始时的折叠状态
        n: "子系统菜单",
    }
}
export { SgiTreeEO };
export default SgiTreeEO;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiTreeEO.js